import { TABLA_CAMIONES_CON_REMITO } from '../../../../../config/tables'
import CuadroDeMando from '../../../../../models/dashboard/cuadro_de_mando'
import { COLUMNS } from './constantesCamionesConRemito'
import { toast } from 'react-toastify'

export function parseData (data) {
  const parsedData = []
  if (data && data.filas_procesadas > 0) {
    data.filas.forEach((entry) => {
      return parsedData.push({ ...entry })
    })
  }
  return parsedData
}

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: false
      },
      id: TABLA_CAMIONES_CON_REMITO
    })
    CuadroDeMando.getCamionesConRemito()
      .then((d) => {
        const data = parseData(d)
        const customToolbar = null

        if (data && data.length > 0) {
          dispatch({
            type: 'SHOW_TABLA_REMITOS',
            newValue: true
          })
        }
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS,
            data: data,
            title: 'Remitos',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              download: false,
              filter: false,
              search: false,
              viewColumns: false
            }
          },
          id: TABLA_CAMIONES_CON_REMITO
        })
      })
      .catch((e) => {
        console.log(e)
        toast.error('Error al consultar los camiones con remito.')
      })
  }
}
